module.exports = __webpack_public_path__ + "assets/img/blaetterCat.6d895b42.jpg";